import ImageLoaderV3 from './src/main';
import ImageControll from './src/ImageCtrl';
import '@patsnap-biz/design-tokens/scss/_flex.scss';

window.rvTrack = window.rvTrack || (() => null);

export default ImageLoaderV3;

export const ImageCtrl = ImageControll;
